export default __webpack_public_path__ + "static/bottom-BR-65429f98079ab832bbb94e2bce6d31db.svg";